import React, {
  useEffect,
  useRef,
  useState,
} from "react";

import {
  Link,
  useParams,
  useNavigate,
} from "react-router-dom";

import {
  useDispatch,
  useSelector,
} from "react-redux";

import {
  FiChevronRight,
  FiHome,
  FiUser,
  FiMail,
  FiCreditCard,
  FiLoader,
  FiAlertCircle,
  FiSave,
  FiEye,
  FiEyeOff,
} from "react-icons/fi";

import toast from "react-hot-toast";

import {
  getUsers,
  edituserprofile, changePassword
} from "../../store/slices/profile";


const EditUserProfile = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const navigate = useNavigate();

  const {
    users,
    usersLoading,
    error,
  } = useSelector(
    (state) => state.profile
  );

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [walletAddress, setWalletAddress] = useState("");

  const [validationError, setValidationError] =
    useState("");

  const [updating, setUpdating] =
    useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [changingPassword, setChangingPassword] = useState(false);
  const [passwordError, setPasswordError] = useState("");


  const fetchedUserId = useRef(null);

  useEffect(() => {
    if (!id) {
      return;
    }

    // Prevent duplicate API call
    if (fetchedUserId.current === id) {
      return;
    }

    fetchedUserId.current = id;

    dispatch(
      getUsers({
        id: id,
        page: 1,
        limit: 1,
      })
    );
  }, [dispatch, id]);



  useEffect(() => {
    if (
      !Array.isArray(users) ||
      users.length === 0
    ) {
      return;
    }

    const user =
      users.find(
        (item) =>
          String(item?._id) === String(id) ||
          String(item?.userId) === String(id)
      ) || users[0];

    if (!user) {
      return;
    }

    console.log(
      "USER RESPONSE:",
      user
    );

    setName(
      user?.name ||
      user?.firstName ||
      ""
    );

    setEmail(
      user?.email ||
      ""
    );

    setWalletAddress(
      user?.walletAddress ||
      ""
    );
  }, [users, id]);


  const handleChangePassword = async (e) => {
    e.preventDefault();

    setPasswordError("");

    if (!id) {
      setPasswordError("User ID is missing.");
      return;
    }

    if (!newPassword) {
      setPasswordError("Please enter a new password.");
      return;
    }

    if (newPassword.length < 6) {
      setPasswordError(
        "New password must be at least 6 characters."
      );
      return;
    }

    if (!confirmPassword) {
      setPasswordError(
        "Please confirm the new password."
      );
      return;
    }

    if (newPassword !== confirmPassword) {
      setPasswordError(
        "New password and confirm password do not match."
      );
      return;
    }

    try {
      setChangingPassword(true);

      const response = await dispatch(
        changePassword({
          userId: id,
          newPassword: newPassword,
        })
      ).unwrap();

      toast.success(
        response?.message ||
        "Password changed successfully."
      );

      setNewPassword("");
      setConfirmPassword("");

    } catch (err) {
      console.error(
        "CHANGE PASSWORD ERROR:",
        err
      );

      toast.error(
        typeof err === "string"
          ? err
          : err?.message ||
          "Failed to change password."
      );

      setPasswordError(
        typeof err === "string"
          ? err
          : err?.message ||
          "Failed to change password."
      );

    } finally {
      setChangingPassword(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setValidationError("");

    if (!id) {
      setValidationError(
        "User ID is missing."
      );
      return;
    }

    const trimmedName = name.trim();
    const trimmedEmail = email.trim();
    const trimmedWalletAddress =
      walletAddress.trim();


    // =======================================================
    // NAME VALIDATION
    // =======================================================

    if (!trimmedName) {
      setValidationError(
        "Please enter your name."
      );
      return;
    }


    // =======================================================
    // EMAIL VALIDATION
    // =======================================================

    if (!trimmedEmail) {
      setValidationError(
        "Please enter your email."
      );
      return;
    }

    const emailRegex =
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(trimmedEmail)) {
      setValidationError(
        "Please enter a valid email address."
      );
      return;
    }


    // =======================================================
    // PAYLOAD
    // =======================================================

    const payload = {
      userId: id,
      name: trimmedName,
      email: trimmedEmail,
      walletAddress: trimmedWalletAddress,
    };


    // =======================================================
    // UPDATE
    // =======================================================

    try {
      setUpdating(true);

      const response = await dispatch(
        edituserprofile(payload)
      ).unwrap();

      toast.success(
        response?.message ||
        "Profile updated successfully"
      );

      // Go back after successful update
      navigate(-1);

    } catch (err) {
      console.error(
        "UPDATE USER ERROR:",
        err
      );

      toast.error(
        typeof err === "string"
          ? err
          : err?.message ||
          "Failed to update profile"
      );

    } finally {
      setUpdating(false);
    }
  };


  const errorMessage =
    validationError ||
    error;

  const isLoading =
    usersLoading ||
    updating ||
    changingPassword;

  return (
    <div className="gi-referral-page">

      <div className="gi-breadcrumb">

        <Link to="/dashboard">
          <FiHome />
          Dashboard
        </Link>

        <FiChevronRight
          className="gi-breadcrumb-arrow"
        />

        <span
          onClick={() => navigate(-1)}
          style={{
            cursor: "pointer",
          }}
        >
          Users
        </span>

        <FiChevronRight
          className="gi-breadcrumb-arrow"
        />

        <span>
          Edit User Profile
        </span>

      </div>


      {/* =====================================================
          FORM CARD
      ===================================================== */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "20px",
          alignItems: "start",
        }}
      >
        <section className="gi-transfer-card">

          {usersLoading && !users?.length ? (

            <div className="gi-table-message">

              <FiLoader
                className="gi-transfer-spinner"
              />

              Loading user...

            </div>

          ) : (

            <form
              onSubmit={handleSubmit}
              className="gi-transfer-form"
            >

              {/* =================================================
                NAME
            ================================================= */}

              <div className="gi-transfer-form-group">

                <label htmlFor="name">
                  Name
                  <span>*</span>
                </label>

                <div className="gi-transfer-input-wrapper">

                  <FiUser />

                  <input
                    id="name"
                    type="text"
                    value={name}
                    onChange={(e) => {
                      setName(
                        e.target.value
                      );

                      setValidationError("");
                    }}
                    placeholder="Enter your name"
                    className="gi-transfer-input"
                    disabled={isLoading}
                    autoComplete="name"
                  />

                </div>

              </div>


              {/* =================================================
                EMAIL
            ================================================= */}

              <div className="gi-transfer-form-group">

                <label htmlFor="email">
                  Email
                  <span>*</span>
                </label>

                <div className="gi-transfer-input-wrapper">

                  <FiMail />

                  <input
                    id="email"
                    type="email"
                    value={email}
                    onChange={(e) => {
                      setEmail(
                        e.target.value
                      );

                      setValidationError("");
                    }}
                    placeholder="Enter your email"
                    className="gi-transfer-input"
                    disabled={isLoading}
                    autoComplete="email"
                  />

                </div>

              </div>


              {/* =================================================
                WALLET ADDRESS
            ================================================= */}

              <div className="gi-transfer-form-group">

                <label htmlFor="walletAddress">
                  Wallet Address
                </label>

                <div className="gi-transfer-input-wrapper">

                  <FiCreditCard />

                  <input
                    id="walletAddress"
                    type="text"
                    value={walletAddress}
                    onChange={(e) => {
                      setWalletAddress(
                        e.target.value
                      );

                      setValidationError("");
                    }}
                    placeholder="Enter wallet address"
                    className="gi-transfer-input"
                    disabled={isLoading}
                    autoComplete="off"
                  />

                </div>

              </div>


              {/* =================================================
                ERROR
            ================================================= */}

              {errorMessage && (

                <div className="gi-transfer-error">

                  <FiAlertCircle />

                  <span>
                    {errorMessage}
                  </span>

                </div>

              )}


              {/* =================================================
                SUBMIT
            ================================================= */}

              <button
                type="submit"
                className="gi-transfer-submit"
                disabled={isLoading}
              >

                {updating ? (

                  <>
                    <FiLoader
                      className="gi-transfer-spinner"
                    />

                    Updating...
                  </>

                ) : (

                  <>
                    <FiSave />

                    Update Profile
                  </>

                )}

              </button>

            </form>

          )}

        </section>

        <section
          className="gi-transfer-card"
          style={{ marginTop: "20px" }}
        >
          <form
            onSubmit={handleChangePassword}
            className="gi-transfer-form"
          >

            <div
              style={{
                marginBottom: "20px",
              }}
            >
              <h3
                style={{
                  margin: 0,
                  fontSize: "20px",
                  fontWeight: "600",
                }}
              >
                Change Password
              </h3>

              <p
                style={{
                  marginTop: "6px",
                  color: "#777",
                  fontSize: "14px",
                }}
              >
                Set a new password for this user.
              </p>
            </div>

            {/* NEW PASSWORD */}

            <div className="gi-transfer-form-group">
              <label htmlFor="newPassword">
                New Password
                <span>*</span>
              </label>

              <div
                className="gi-transfer-input-wrapper"
                style={{ position: "relative" }}
              >
                <input
                  id="newPassword"
                  type={showNewPassword ? "text" : "password"}
                  value={newPassword}
                  onChange={(e) => {
                    setNewPassword(e.target.value);
                    setPasswordError("");
                  }}
                  placeholder="Enter new password"
                  className="gi-transfer-input"
                  disabled={changingPassword}
                  autoComplete="new-password"
                  style={{ paddingRight: "45px" }}
                />

                <button
                  type="button"
                  onClick={() => setShowNewPassword((prev) => !prev)}
                  disabled={changingPassword}
                  style={{
                    position: "absolute",
                    right: "12px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    border: "none",
                    background: "transparent",
                    padding: 0,
                    cursor: "pointer",
                    color: "#777",
                    display: "flex",
                    alignItems: "center",
                  }}
                  aria-label={
                    showNewPassword
                      ? "Hide password"
                      : "Show password"
                  }
                >
                  {showNewPassword ? <FiEyeOff size={18} /> : <FiEye size={18} />}
                </button>
              </div>
            </div>

            <div className="gi-transfer-form-group">
              <label htmlFor="confirmPassword">
                Confirm Password
                <span>*</span>
              </label>

              <div
                className="gi-transfer-input-wrapper"
                style={{ position: "relative" }}
              >
                <input
                  id="confirmPassword"
                  type={showConfirmPassword ? "text" : "password"}
                  value={confirmPassword}
                  onChange={(e) => {
                    setConfirmPassword(e.target.value);
                    setPasswordError("");
                  }}
                  placeholder="Confirm new password"
                  className="gi-transfer-input"
                  disabled={changingPassword}
                  autoComplete="new-password"
                  style={{ paddingRight: "45px" }}
                />

                <button
                  type="button"
                  onClick={() =>
                    setShowConfirmPassword((prev) => !prev)
                  }
                  disabled={changingPassword}
                  style={{
                    position: "absolute",
                    right: "12px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    border: "none",
                    background: "transparent",
                    padding: 0,
                    cursor: "pointer",
                    color: "#777",
                    display: "flex",
                    alignItems: "center",
                  }}
                  aria-label={
                    showConfirmPassword
                      ? "Hide password"
                      : "Show password"
                  }
                >
                  {showConfirmPassword ? (
                    <FiEyeOff size={18} />
                  ) : (
                    <FiEye size={18} />
                  )}
                </button>
              </div>
            </div>
            {/* PASSWORD ERROR */}

            {passwordError && (
              <div className="gi-transfer-error">

                <FiAlertCircle />

                <span>
                  {passwordError}
                </span>

              </div>
            )}

            {/* CHANGE PASSWORD BUTTON */}

            <button
              type="submit"
              className="gi-transfer-submit"
              disabled={changingPassword}
            >

              {changingPassword ? (
                <>
                  <FiLoader
                    className="gi-transfer-spinner"
                  />

                  Changing Password...
                </>
              ) : (
                <>
                  <FiSave />

                  Change Password
                </>
              )}

            </button>

          </form>
        </section>
      </div>
    </div>
  );
};


export default EditUserProfile;